import React, { useState, useCallback, useEffect } from 'react';
// import { LOCALIZATION_API } from 'app/constants/api';
import { Provider as LanguageProvider } from './LanguageContext';

function Localize({ children }: { children: React.ReactNode }) {
    const [messages, setMessages] = useState({});
    const [language, setLanguage] = useState('en');

    const setupLanguageMessages = (language: string) => {
        return import(`./languages/${language}.json`).then((messages) => {
            setMessages(messages.default);
        });
    };

    const setupLanguageMessagesCallback = useCallback(() => {
        setupLanguageMessages(language);
    }, [language]);

    useEffect(() => {
        setupLanguageMessagesCallback();
    }, [setupLanguageMessagesCallback]);

    return (
        <LanguageProvider
            value={{
                changeLanguage: (language: string) => {
                    setLanguage(language);
                    setupLanguageMessagesCallback();
                },
                messages,
            }}>
            {Object.keys(messages).length ? children : null}
        </LanguageProvider>
    );
}

export default Localize;
